import classNames from 'classnames';
import type { FC } from 'react';
import { t } from 'src/lib/player/i18n';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';
import MultiSelect from './MultiSelect';

interface Props {
  availableTags: Map<string, Array<[string, number]>>;
  itemStyle: React.CSSProperties;
  selectedTags: Map<string, Array<string>>;
  defaultSelectedTags: Map<string, Array<string>>;
  onReset: () => void;
  onToggleTag: (tagKey: string, value: string) => void;
}

export const ParticipantsFilter: FC<Props> = ({
  availableTags,
  defaultSelectedTags,
  itemStyle,
  selectedTags,
  onReset,
  onToggleTag,
}) => {
  const resetIsDisabled = compareTagsMap(selectedTags, defaultSelectedTags);

  return (
    <div key="starter-filter-row" className="starter-list-filter" style={itemStyle}>
      {Array.from(availableTags.keys(), (tagKey) => (
        <div key={`tag-select-${tagKey}`}>
          <MultiSelect
            tagKey={tagKey}
            values={availableTags.get(tagKey) || []}
            selectedValues={selectedTags.get(tagKey)}
            onToggle={onToggleTag}
          />
        </div>
      ))}
      <div key="deselect-tag-button">
        <div
          className={classNames('starter-list-button', {
            'starter-list-button-disabled': resetIsDisabled,
          })}
          {...(!resetIsDisabled &&
            onClickGenerator(() => {
              if (resetIsDisabled) return;
              onReset();
            }))}
        >
          {t('list.DESELECT_TAG')}
        </div>
      </div>
    </div>
  );
};

const compareTagsMap = (map1: Map<string, Array<string>>, map2: Map<string, Array<string>>) => {
  if (map1.size !== map2.size) {
    return false;
  }

  for (const [key, values1] of map1.entries()) {
    const values2 = map2.get(key);
    if (!values2) {
      return false;
    }
    const set1 = new Set(values1);
    const set2 = new Set(values2);
    if (set1.size !== set2.size) {
      return false;
    }
    for (const v of set1) {
      if (!set2.has(v)) {
        return false;
      }
    }
  }

  return true;
};
